import { Observable } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { StorageService } from './storage.service';
import { storeInSession } from './store-in-session';

export const cacheInSession =
  (service: StorageService, key: string) =>
  <T>(obs: Observable<T>): Observable<T | null> =>
    obs.pipe(storeInSession(service, key), startWith(service.getFromSessionStorage<T>(key)));
